import API from "./APIService"
import BaseService from "./BaseService"

class SkillsService extends BaseService {
	component = null

	constructor(component = null) {
		super()
		this.component = component
	}

	baseServicePath = () => {
		return API.url("skills")
	}
}

export default SkillsService
